import { idConnectStorage } from './idConnectStorage';
import { IdConnectConfiguration, IdsAvailableType } from '@idConnect/types';
import { getAdtechpassValueProxy } from '@shared/helpers/idGraph/getAdtechpassValueProxy';

export const getStorageIdGraphData = (
  idConnectConfiguration: IdConnectConfiguration,
): IdsAvailableType | null => {
  const idConnectStorageData = idConnectStorage(
    idConnectConfiguration.IDCONNECT_STORAGE_TYPE,
  ).get(idConnectConfiguration.IDCONNECT_DATA_STORAGE);
  const isIdConnectStorageDataDefined: boolean =
    idConnectStorageData !== undefined && idConnectStorageData !== null;

  if (
    isIdConnectStorageDataDefined &&
    idConnectStorageData?.connectId?.idGraph?.[0]
  ) {
    const [idGraphData] = idConnectStorageData.connectId.idGraph;
    idGraphData.atid = getAdtechpassValueProxy(idGraphData.atid);

    return {
      ...idGraphData,
      domain: idConnectStorageData?.connectId?.domain,
      ttl: idConnectStorageData?.connectId?.ttl,
    };
  }
  return null;
};
